import axios from '../request/http.js'

class Kitchen {
  /* 帮厨列表 */
  static getKitchenList(canteenId) {
    let url = `/zzd/api/back/kitchen/list?canteenId=${canteenId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 删除帮厨 */
  static postDelKitchen(data) {
    let url = `/zzd/api/back/kitchen/del`
    return axios.post(url,data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 添加帮厨 */
  static postAddKitchen(data) {
    let url = `/zzd/api/back/kitchen/set`
    return axios.post(url,data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default Kitchen